import store from '@/store'

export const checkPermission = (permission) => {
  const permissionList = store.state.user.permissions?.map((item) => item.key)
  return permissionList?.includes(permission)
}
